import { Locale } from '@mai-team-amusement/core';
import type { AppNamespace, LeafKey } from '@mai-team-amusement/i18n';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { enUs, type ClockResources } from './en-US.js';
import { ja } from './ja.js';
import { zhHans } from './zh-Hans.js';
import { zhHant } from './zh-Hant.js';

export const CLOCK_NAMESPACE = 'clock';

export const clockResources: Record<Locale, ClockResources> = {
  [Locale.ZhHans]: zhHans,
  [Locale.ZhHant]: zhHant,
  [Locale.EnUs]: enUs,
  [Locale.Ja]: ja,
};

export const clockNamespace: AppNamespace = { name: CLOCK_NAMESPACE, resources: clockResources };

export type ClockKey = LeafKey<ClockResources>;

export type ClockTranslate = (
  key: ClockKey,
  values?: Readonly<Record<string, string | number>>,
) => string;

/** Type-checked translator for this app's namespace. */
export function useClockT(): ClockTranslate {
  const { t } = useTranslation(CLOCK_NAMESPACE);
  return useCallback<ClockTranslate>((key, values = {}) => t(key, values), [t]);
}
